export const getTextFromClipboard = async (): Promise<string> => {
  const text = await navigator.clipboard.readText();

  return text;
};
